import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-truck",
  "use": "icon-truck-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-truck\"><path d=\"M691 528h100q16 0 25-11.5t5-27.5l-28-97q-4-12-15-20t-24-8h-63q-14 0-24 10t-10 24v96q0 14 10 24t24 10zm0-34v-96h64l2 1 2 1 27 94h-95zm252-33q-31-14-34-20l-56-139q-5-16-20-27t-32-11H589v-28q0-22-15.5-37.5T536 183H54q-22-1-37.5 15T1 236v441q0 22 15.5 37.5T54 730h62q6 36 34 60t64.5 24 65-24 34.5-60h212l3 1h123q5 37 33.5 61.5t66 24.5 66-24.5T851 731h103q18 0 31.5-13.5T999 686V518q0-21-19-36-11-9-37-21zM752 656q25 0 43 18t18 43-18 43-43.5 18-43.5-18-18-43 18-43 44-18zm-538-4q25 0 43 18t18 43.5-18 43.5-43 18-43-18-18-43.5 18-43.5 43-18zM43 236q0-5 3.5-8t7.5-3h482q4 0 7.5 3t3.5 8v70h246q5 0 10.5 4t6.5 9l60 145q7 13 26 23 11 7 35 15l1 1q17 6 21 10 6 5 6 16v150q0 4-2.5 6.5T951 688H848q-10-31-36.5-51t-60-20-60 20-36.5 51H312q-9-33-36-53.5T215 614t-61 20.5-36 53.5H54q-4 0-7.5-3t-3.5-8V236z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/truck.svg
// module id = 1136
// module chunks = 2